import { Outlet } from "react-router";
import { NavMenu } from "fragments/navMenu/NavMenu";

export const Layout = () => {

  return (
      <div className="main-layout">
        <header className="nav-menu">
          <NavMenu />
        </header>
        <div className="main-content">
          <Outlet />
        </div>
      </div>
  );
};
